export const isBlank = (s) => {
	let emptyString = false;
	if(s && typeof (s) == "string"){
		emptyString = s.trim().length <= 0;
	}
	else if(!s && typeof (s) == "string"){
		emptyString = true;
	}
	return s == null || emptyString;
};

export const isNotBlank = (s) => !isBlank(s);

export const toNumeric = (s) => {
	if(isBlank(s)){
		return "";
	}
	return s.replace(/[^0-9]+/g, "");
};

export const toNumber = (s) => {
	if(isBlank(s)){
		return "";
	}
	return Number(toNumeric(s));
};


export const emptyIfBlank = (s) => (isBlank(s) ? "" : s);

export const nullIfEmpty = (s) => ((s == "") ? null : s);

export const nullIfBlank = (s) => ((isBlank(s)) ? null : s);

export const buscarIniciais = (nome) => {
	if(isBlank(nome)){
		return "";
	}

	// eslint-disable-next-line prefer-regex-literals
	const rgx = new RegExp(/(\p{L}{1})\p{L}+/, "gu");

	let initials = [...nome.matchAll(rgx)] || [];

	initials = (
		(initials.shift()?.[1] || "") + (initials.pop()?.[1] || "")
	).toUpperCase();
	return initials;
};

export const removerCaracteresEspeciais = (s) => {
	if(s == null){
		return "";
	}
	try {
		return String(s).normalize("NFD").replace(/\p{Diacritic}/gu, "");
	}
	catch (e){
		console.error(`Erro ao extrair apenasLetrasENumeros de ${s}`);
		throw e;
	}
};

export const manterApenasLetrasENumerosEEspacos = (s) => {
	if(s == null){
		return "";
	}
	try {
		return String(s).normalize("NFD").replace(/[^a-zA-Z0-9]+/g, "");
	}
	catch (e){
		console.error(`Erro ao extrair apenasLetrasENumeros de ${s}`);
		throw e;
	}
};

export const manterApenasLetrasENumeros = (s) => {
	if(s == null){
		return "";
	}
	try {
		return String(s).normalize("NFD").replace(/[^a-zA-Z0-9]+/g, "");
	}
	catch (e){
		console.error(`Erro ao extrair apenasLetrasENumeros de ${s}`);
		throw e;
	}
};

export const manterApenasLetras = (s) => {
	if(s == null){
		return "";
	}
	try {
		return String(s).normalize("NFD").replace(/[^a-zA-Z]+/g, "");
	}
	catch (e){
		console.error(`Erro ao extrair apenasLetras de ${s}`);
		throw e;
	}
};

export const manterApenasNumeros = (s) => {
	if(s == null){
		return "";
	}
	try {
		return String(s).normalize("NFD").replace(/\D/g, "");
	}
	catch (e){
		console.error(`Erro ao extrair apenasNumeros de ${s}`);
		throw e;
	}
};

export const manterApenasNumerosDecimaisComDoisDigitos = (s) => {
	if(s == null){
		return "";
	}
	try {
		return String(s).normalize("NFD").replace(/^(\d{0,9}\.)?\d{1,2}$/g, "");
	}
	catch (e){
		console.error(`Erro ao extrair apenasNumeros de ${s}`);
		throw e;
	}
};

export const manterApenasCaracteresPermitidos = (texto, caracteres) => {
	if(texto == null || texto.length <= 0){
		return "";
	}
	if(caracteres == null || caracteres.length <= 0){
		return "";
	}
	let textoFinal = "";
	for(const c of texto){
		if(caracteres.includes(c)){
			textoFinal += c;
		}
	}
	return textoFinal;
};
